<template>
  <div class="content background6" style="height: 100%;">
    <div class="tableBox9">
      <div class="tableMes">
        <div class="table">
          <el-tabs v-model="activeNameTree" type="card" @tab-click="handleClickTree">
            <el-tab-pane :label="$t('label_429')" name="first">
              <tree :dataTree="treeData" :treeType="0" @getDeviceMes="getDeviceMes"></tree>
            </el-tab-pane>
            <el-tab-pane :label="$t('label_161')" name="second">
              <tree :dataTree="treeData2" :treeType="1" @getDeviceMes="getDeviceMes"></tree>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <div class="tableBox10">
      <div class="tableMes">
        <div class="table" style="padding: 0">
          <div class="treeMes" v-if="getTreeMes=='1'">
            <p class="title"><span class="spot">{{deviceDetailMes.name}}</span>{{$t('label_1015')}}</p>
            <div class="chooseBox spaceBetween">
              <div class="selectBox">
                <div>
                  <div class="selectChoose">
                    <div class="selectText">
                      <p>{{$t('label_593')}}</p>
                    </div>
                    <div class="select" style="width:350px">
                      <el-input v-model="code" clearable></el-input>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="selectChoose">
                    <div class="selectText">
                      <p>{{$t('label_752')}}</p>
                    </div>
                    <div class="select" style="width:350px">
                      <el-date-picker v-model="Readytime" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="daterange"
                                      :range-separator="$t('label_264')" :start-placeholder="$t('label_329')" :end-placeholder="$t('label_388')">
                      </el-date-picker>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="selectChoose">
                    <div class="selectText">
                      <p>{{$t('label_734')}}</p>
                    </div>
                    <div class="select" style="width:150px">
                      <el-select v-model="selectedTop" placeholder="请选择">
                        <el-option
                          v-for="item in topOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="buttonBox">
                <div>
                  <div class="chooseButton sendButton" @click="search({pageNum: 1,pageSize:pageSize,})"><i
                    class="el-icon-search"></i>{{$t('btn_2')}}</div>
                </div>
              </div>
            </div>
            <div class="spotMes2Box">
              <div class="buttonBox" style="width:350px">
                <div>
<!--                  <div class="chooseButton searchButton" @click="exportClick" v-if="MenuRoleList.indexOf('61')>=0"><i class="el-icon-download"></i>导出</div>-->
                </div>
              </div>
              <div class="spotMesBox spotMesBoxs" style="height:107%;">
                <el-tabs v-model="activeNameSpot" @tab-click="search">
                  <el-tab-pane :label="$t('label_1023')" name="g" v-if="MenuRoleList.indexOf('9')>=0">
                    <inspectionGraphicStatistics ref="inspectionGraphicStatisticsDisplay"></inspectionGraphicStatistics>
                  </el-tab-pane>
                  <el-tab-pane :label="$t('label_1024')" name="t" v-if="MenuRoleList.indexOf('13')>=0">
                    <inspectionTabularStatistics ref="inspectionTabularStatisticsDisplay"></inspectionTabularStatistics>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 导出 -->
<!--    <exportMes :exportTitle="exportTitle" :exportData="tableDataTreeTimeExport" :exportList="exportList"-->
<!--               ref="exportBox"></exportMes>-->
  </div>
</template>

<script>
import "@/assets/css/map/map.css"
import "@/assets/css/common/spot.css"
import Page from "@/components/common/page";
import utils from '@/utils/utils'
import tree from "@/components/list/tree/maintainTree";
import SpotCheck from "@/assets/js/spotCheck/spotCheck.js";
import file from "@/assets/js/file/file.js";
import popMesBox from "@/components/list/popover/pop";
import inspectionTabularStatistics from "@/components/list/tabPane/inspectionTabularStatistics";
import inspectionGraphicStatistics from "@/components/list/tabPane/inspectionGraphicStatistics";
import exportMes from "@/components/list/export/export";
import inspectionStatisticsApi from "@/assets/js/statistics/statistics.js";

export default {
  name: 'inspectionStatistics',
  components: {
    Page,
    tree,
    popMesBox,
    inspectionTabularStatistics,
    inspectionGraphicStatistics,
    exportMes
  },
  data() {
    return {
      activeNameSpot: 'g',
      dateValue: [],
      pageNum: 1,
      pageSize: 10,
      pageCount: 0,
      topOptions: [
        { value: 10, label: '十' },
        { value: 20, label: '二十' },
        { value: 0, label: '全て' }
      ],
      selectedTop: 10,
      Readytime: '',
      code: '',
      getTreeMes: '1',
      img: '',
      checked: false,
      dialogImg: false,
      dialogVideo: false,
      dialogSpotRemark: false,
      deviceDetailMes: {},
      dialogSpotResult: false,
      MenuRoleList: [],
      tableDataTreeTimeExport: [],
      newType: {
        id: '',
        remark: ''
      },
      exportList: [{
        column: 'itemName',
        title: '点检项目',
        headerAlign: 'center',
        align: 'center',
        width: '200px'
      }, {
        column: 'ngCount',
        title: 'NG次数',
        headerAlign: 'center',
        align: 'center',
        width: '200px'
      }, {
        column: 'ngRate',
        title: 'NG率',
        headerAlign: 'center',
        align: 'center',
        width: '200px'
      }],
      exportTitle: '点检统计',
      tableDataTree: [],
      tableDataTreeInfo: [],
      tableDataInfo: [],
      typeName: '',
      deptName: '',
      treeData: {
        dataDevice: [],
        searchShow: true,
        statusShow: false,
        statusListShow: true,
        cardShow: true,
        dataAll: true,
        funtoGetMes: '2'
      },
      treeData2: {
        dataDevice: [],
        searchShow: true,
        statusShow: false,
        statusListShow: true,
        cardShow: true,
        dataAll: true,
        funtoGetMes: '3'
      },
      checkList: [],
      tableDataTreeTime: [],
      activeNameTree: 'first',
      status: '',
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    selectedTop(newVal) {
      if (newVal === 0) {
        this.pageSize = 999999;
      } else {
        this.pageSize = newVal;
      }
    }
  },
  methods: {
    handleClickTree(tab, event) {
      this.getTreeMes = '1';
      this.deviceDetailMes = {};
    },
    search() {
      var p = {
        beginTime: this.Readytime[0] + ' 00:00:00',
        endTime: this.Readytime[1] + ' 23:59:59',
        name: this.code,
        type: this.deviceDetailMes.type,
        id: this.deviceDetailMes.id,
        pageNum: 1,
        pageSize: this.pageSize,
      }
      this.$nextTick(() => {
        if (this.activeNameSpot == 'g') {
          this.$refs.inspectionGraphicStatisticsDisplay.newMes(p)
        } else {
          this.$refs.inspectionTabularStatisticsDisplay.newMes(p)
        }
      })

      // 调用导出数据接口
      inspectionStatisticsApi.checkStatistics(p).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.tableDataTreeTimeExport = data.data;
        }
      }).catch((response) => {
        console.log(response)
      })
    },

    // 初始化时间
    initDate() {
      var date = new Date();
      var seperator = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      // 开始时间
      var beginTime = year + seperator + this.zero(month) + seperator + '01';
      // 结束时间
      var endTime = this.getday(year + seperator + this.zero(month) + seperator + this.zero(day));
      this.Readytime = [beginTime, endTime];
      this.search();
    },

    // 补0
    zero(i) {
      return i > 9 ? i : '0' + i;
    },

    // 导出
    exportClick() {
      this.$refs.exportBox.setExportExcel();
    },

    // 最后一天
    getday(val) {
      var nextMonthFirstDay = new Date(val.substring(0, 4), val.substring(5, 7), 1);
      var oneDay = 1000 * 60 * 60 * 24;
      var lastTime = new Date(nextMonthFirstDay - oneDay);
      var day = lastTime.getDate();
      var month = parseInt(lastTime.getMonth() + 1);
      if (month < 10) {
        month = '0' + month
      }
      if (day < 10) {
        day = '0' + day
      }
      return lastTime.getFullYear() + '-' + month + '-' + day;
    },

    getDeviceMes(data) {
      if (data.name == '全部') {
        this.deviceDetailMes = {};
        this.deviceDetailMes.type = 0
        if (this.activeNameTree == 'second') {
          this.deviceDetailMes.type = 2
        }
        this.deviceDetailMes.id = null
        this.search();
      } else {
        this.deviceDetailMes = data;
        this.search();
      }
    },
  },
  created() {
    this.MenuRoleList = this.$store.getters.getMenu;
    this.initDate();
  }
}
</script>

<style>
.spotMesBoxs .el-tabs__nav-scroll {
  display: flex;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/pages/statisticalAnalysis/checkStatistics.vue